export const MONTHLY = "MONTHLY";
export const TOTAL = "TOTAL";
